import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { css } from "styled-components";

twoButtonModalStyles.submitButton = {
    variant: "primary",
};
